const SearchSchema = () => ({
  title: 'AgSUS Busca',
  fieldsets: [
    { id: 'default', title: 'Busca', fields: ['placeholder'] },
  ],
  properties: {
    placeholder: {
      title: 'Texto do campo',
      description: 'Placeholder exibido no campo de busca.',
      default: 'Pesquisar',
    },
  },
  required: [],
});

export default SearchSchema;
